import React from 'react';
import tw from 'twin.macro';

import NumberOne from '@/assets/images/NumberOneImage.svg';
import { BigTitle, SubBody, SubTitle } from '@/components';
import InfoBlock from '@/components/ui/info-block/info-block';
const Info1 = [
  { title: '11 место', caption: 'по активам среди 22 казахстанских банков' },
  { title: 'kzBB', caption: 'Национальный рейтинг' }
];
const Info2 = [
  { title: '69', caption: 'млрд тенге собственный капитал' },
  { title: '1 264', caption: 'млрд тенге совокупных активов' },
  { title: '302', caption: 'млрд тенге кредитный портфель' },
  { title: '604', caption: 'млрд тенге депозитный портфель' }
];
const Info3 = [
  { title: '5,6×', caption: 'рост депозитного портфеля' },
  { title: '14,9×', caption: 'рост кредитного портфеля' },
  { title: '3×', caption: 'рост активов и обязательств' },
  { title: '19', caption: 'млрд тенге чистая прибыль' }
];
function LandingInfoBlock3() {
  return (
    <>
      <div>
        <BigTitle
          text={'Freedom Bank — лидер по запуску цифровых продуктов в Казахстане'}
          twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] mb-10 max-w-[1000px]`}
        />
        <SubTitle
          text={
            <span>
              Наши клиенты получают ипотеку и автокредиты онлайн, без сбора документов. Мы — лидер <br /> по количеству
              выданных ипотек по государственной программе “7-20-25”.{' '}
            </span>
          }
        />
        <div tw='flex flex-col sm:grid grid-cols-2 col-gap-10 sm:mt-20 mt-10'>
          <div tw='flex flex-col text-center items-center gap-5'>
            <img src={NumberOne} alt='icon' />
            <SubTitle
              text={'Первое место в мире по цифровизации ипотеки'}
              variant={'bold'}
              twStyle={tw`max-w-[300px]`}
            />
            <SubTitle text={'Мы оцифровали оформление ипотеки на 100% '} twStyle={tw`text-secondary`} />
          </div>
          <div tw='flex flex-col sm:gap-20 gap-10 sm:mt-0 mt-10 '>
            <div>
              <SubTitle text={'Рейтинги'} variant={'bold'} twStyle={tw`mb-5`} />
              <InfoBlock title={'B-/B-, прогноз позитивный'} caption={'Рейтинг банка от S&P Global Ratings'} />
              <div tw='grid grid-cols-2 row-gap-10 gap-10  mt-5'>
                {Info1.map(item => (
                  <InfoBlock caption={item.caption} title={item.title} key={item.title} />
                ))}
              </div>
            </div>
            <div>
              <SubTitle text={'Капитал и активы'} variant={'bold'} />
              <div tw='grid grid-cols-2 row-gap-10 gap-10 mt-5'>
                {Info2.map(item => (
                  <InfoBlock caption={item.caption} title={item.title} key={item.title} />
                ))}
              </div>
            </div>
            <div>
              <SubTitle text={'Показатели роста и прибыль в 2022'} variant={'bold'} />
              <div tw='grid grid-cols-2 row-gap-10 gap-10  mt-5'>
                {Info3.map(item => (
                  <InfoBlock caption={item.caption} title={item.title} key={item.title} />
                ))}
              </div>
            </div>
            <div tw='text-left'>
              <SubBody text={'По данным nationalbank.kz на 01.01.2023'} twStyle={tw`text-secondary text-center`} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LandingInfoBlock3;
